var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chain)?_c('div',{staticClass:"head-box"},[(_vm.logoPath)?_c('img',{attrs:{"src":_vm.logoPath}}):_vm._e(),_c('div',{staticClass:"subtitle-2 mx-2"},[_vm._v(_vm._s(_vm.chain.name))]),_c('v-spacer'),_c('v-btn',{attrs:{"icon":"","to":'/chains/' + _vm.chain.url}},[_c('v-icon',[_vm._v("mdi-chevron-right")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }